import { AppRoutes, LoginRoutes } from "@/routes/config";
import { isAuth } from "@/utils/api";
import { getLastAuthRoute } from "@/utils/lastAuthRoute";
import { getQueryFromURL, getSafeRedirectURL } from "@/utils/url";
import { FC, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

type TQuery = {
  redirectUrl: string;
};

export const withGuest: <CP extends {}>(WrappedComponent: FC<CP>) => FC<CP> = (WrappedComponent) => (props) => {
  const [authenticated, setAuthenticated] = useState(isAuth());

  useEffect(() => {
    // Every 5 seconds re-check auth state; redirect away if the user becomes authenticated
    const intervalId = setInterval(() => {
      setAuthenticated(isAuth());
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  if (authenticated) {
    const query = getQueryFromURL<TQuery>();
    const isLoginRoute = LoginRoutes.some((path) => location.pathname === path);
    const fallback = isLoginRoute ? getSafeRedirectURL(getLastAuthRoute(), AppRoutes.home) : AppRoutes.home;

    return <Navigate to={getSafeRedirectURL(query?.redirectUrl, fallback)} replace />;
  }

  return <WrappedComponent {...props} />;
};
